<ul>
    <ng-container *ngFor="let item of metaMenuItems">
        <li class="list-item">
            <app-link *ngIf="item.link as link" [link]="link">
                <span class="menu-link">
                    {{ link.name }}
                    <app-svg-icon iconName="chevron_right"></app-svg-icon>
                </span>
            </app-link>
        </li>
    </ng-container>
</ul>
